import { Link } from 'react-router-dom';
import { heroText } from '@/mocks/home';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[600px] md:h-[720px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20flowing%20liquid%20gradient%20with%20rich%20crimson%20red%20and%20deep%20warm%20black%20tones%2C%20dynamic%20motion%20blur%20effect%2C%20golden%20and%20amber%20accent%20streaks%20flowing%20diagonally%2C%20luxurious%20dark%20artistic%20background%2C%20smooth%20elegant%20color%20transitions%2C%20high%20saturation%20warm%20palette%2C%20modern%20editorial%20style%2C%20no%20recognizable%20objects%2C%20pure%20abstract%20art%2C%20soft%20dreamy%20blur%20on%20edges%2C%20professional%20cinematic%20mood&width=1920&height=1080&seq=hero-bg-main-01&orientation=landscape"
          alt="吃瓜网站线路一 - 网红塌房黑料每日大赛"
          title="吃瓜网站线路一首页背景"
          className="w-full h-full object-cover"
        />
      </div>

      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/55"></div>

      <div className="relative z-10 w-full flex flex-col items-center text-center px-4 md:px-6">
        <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white font-heading leading-tight mb-3">
          {heroText.line1}
        </h1>
        <p className="text-xl md:text-3xl lg:text-4xl text-white/90 font-heading italic mb-6">
          {heroText.line2}
        </p>
        <p className="text-sm md:text-base text-white/70 font-body max-w-2xl mb-10 leading-relaxed">
          {heroText.subtitle}
        </p>
        <Link
          to="/category/all"
          className="inline-flex items-center gap-2 bg-white text-foreground-950 px-10 py-4 rounded-full text-base font-semibold whitespace-nowrap hover:bg-white/90 transition-all duration-200 hover:scale-105 cursor-pointer"
        >
          {heroText.cta}
          <span className="w-6 h-6 flex items-center justify-center">
            <i className="ri-arrow-right-line text-lg"></i>
          </span>
        </Link>
      </div>
    </section>
  );
}